<template>
  <el-form label-width="80px">
    <el-row  :gutter="24" type="flex">
      <el-col  :span="9" sm="9" :xs="0">
        <div style="height: 1px;"></div>
      </el-col>
      <el-col  :span="6" sm="24" :xs="24">
        <div style="margin: 5px">
          <h1 style="margin: 10px 10px">申请人</h1>
          <el-button text style="font-size:20px;bolder:bold;margin: 10px 10px" @click="open"  type="primary">操作指南</el-button>
          <div>
            <div>
              <el-form-item label="申请人" label-styl>
                <el-input v-model="form.name" placeholder="请输入内容"/>
              </el-form-item>
              <el-form-item  label="电话号码">
                <el-input v-model="form.queryphone" placeholder="请输入内容"/>
              </el-form-item>
              <el-button type="primary"  style="width: 50%;border: none;margin: 10px 0px" @click="query">查询</el-button>
            </div>
          </div>
          <div>
            <el-form-item label-width="0">
              <el-table :data="tableData"  style="margin: 10px " border type="selection" @selection-change="handleSelectionChange">
                <el-table-column type="selection"/>
                <el-table-column prop="applynumber" label="申请单号"/>
                <el-table-column prop="ntotalorigmny" label="金额"/>
                <el-table-column prop="status" label="状态"/>
                  <el-table-column label="发票">
                    <template #default="scope">
                      <a :href="scope.row.url">下载</a>
                    </template>
                  </el-table-column>
              </el-table>
            </el-form-item>
          </div>
          <div>
            <div >
              <h2 style="margin: -10px" class="table-text">开票信息</h2>
              <el-button style="width: 25%;margin: 20px 10px" @click="isPersonage='个人'">个人</el-button><el-button style="width: 25%;margin: 20px 10px" @click="isPersonage='企业'">企业</el-button>
            </div >
            <div v-show="isPersonage==='个人'">
              <el-form-item  label="发票抬头*"  inline labe-position >
                <el-input v-model="insterVo.pk_org" placeholder="必填" />
              </el-form-item>
            </div>
            <div v-show="isPersonage==='企业'" >
              <el-form-item  label="发票抬头*" inline labe-position >
                <el-input v-model="insterVo.pk_org" placeholder="必填" style="text-align: left;"/>
              </el-form-item>
              <el-form-item  label="税号*" inline labe-position >
                <el-input v-model="insterVo.identify"  placeholder="必填"/>
              </el-form-item>
              <el-form-item  label="开户行" labe-position >
                <el-input v-model="insterVo.bankdoc" placeholder="选填"  style="text-align: left;"/>
              </el-form-item>
              <el-form-item  label="银行账号" labe-position >
                <el-input v-model="insterVo.bankaccount"  placeholder="选填" style="text-align: left;"/>
              </el-form-item>
              <el-form-item  label="地址"   labe-position >
                <el-input v-model="insterVo.address" placeholder="选填" style="text-align: left;"/>
              </el-form-item>
              <el-form-item  label="电话"   labe-position >
                <el-input  v-model="insterVo.fix_phone" placeholder="选填" style="text-align: left;"/>
              </el-form-item>
            </div>
          </div>
          <div>
            <h2 style="margin: 20px" class="table-text">接收方式</h2>
            <el-form-item label="电话号码"  >
              <el-input v-model="insterVo.buyer_phone" placeholder="必填" />
            </el-form-item>
            <el-form-item label="邮箱"  >
              <el-input v-model="insterVo.mail" placeholder="选填" />
            </el-form-item>
          </div>
          <div>
            <el-button type="primary"  style="width: 50%;border: none;margin: 20px 0px" @click="inster">推送</el-button>
          </div>
        </div>
      </el-col>
    </el-row>

  </el-form>
</template>


<script setup>
import {Dialog} from "vant";
import {reactive, ref} from 'vue';
// import axios  from "@/api/query/axios.js";
import { ElMessage, ElMessageBox } from 'element-plus'
import {getQuery,insterElectronice} from '@/api/query/queryApi.js';
const isPersonage=ref('个人')
const labelPosition = ref('right');
let tableData = ref([])
let gettableData = ref([])
const insterVo=reactive({
  pk_org:'',
  notaxprice: '',
  address: '',
  fix_phone: '',
  bankaccount: '',
  bankdoc: '',
  identify: '',
  applicat_phone:'',
  applicatcode:'',
  applicat:'',
  buyer_phone:'',
  mail:'',
});
const form = reactive({
  name: '',
  queryphone: '',
  pk_org: '',
  phone: '',
  mail: '',
});
const url=require("@/assets/操作指南.jpg")
const open = () => {
  ElMessageBox.alert("<img  src="+url+" style='height: 50%; width: 100%; object-fit: cover;text-align: center'>", '操作指南', {
    dangerouslyUseHTMLString: true,
    customClass: 'messageBox_class',
    showClose:false,
    confirmButtonText: "确定",
    showCancelButton: false,
  });
}




const inster=()=>{
  if (form.name === '') {
    Dialog({
      message: "申请人不能为空!",
      confirmButtonText: "确认",
    });
  } else if (form.queryphone === '') {
    Dialog({
      message: "手机号不能为空!",
      confirmButtonText: "确认",
    });
  }else if (insterVo.pk_org === '') {
    Dialog({
      message: "发票抬头不能为空!",
      confirmButtonText: "确认",
    });
  }else if (isPersonage==='企业'&&insterVo.identify === '') {
    Dialog({
      message: "税号不能为空!",
      confirmButtonText: "确认",
    });
  }else if (insterVo.buyer_phone == '') {
    Dialog({
      message: "接收方式手机号不能为空!",
      confirmButtonText: "确认",
    });
  }else if(gettableData.length!=1){
    Dialog({
      message: "请勾选一行数据!",
      confirmButtonText: "确认",
    });
  }else if(gettableData[0]['status']!=='可开票'){
    Dialog({
      message: "请选择可开票数据!",
      confirmButtonText: "确认",
    });
  }else {
    let data = {
      id:gettableData[0]['id'],
      vbillcode:gettableData[0]['vbillcode'],
      isPersonage:isPersonage.value,
      notaxprice:gettableData[0]['ntotalorigmny'],
      name:insterVo.pk_org,
      applicat:gettableData[0]['name'],
      applicatcode:gettableData[0]['applynumber'],
      buyer_phone:insterVo.buyer_phone,
      mail:insterVo.mail,
      applicat_phone:form.queryphone,
      identify:insterVo.identify,
      bankdoc:insterVo.bankdoc,
      bankaccount:insterVo.bankaccount,
      fix_phone:insterVo.fix_phone,
      address:insterVo.address,
    };
    insterElectronice(data).then((res) => {
      console.log(res)
      if (res.status == 200) {
          Dialog({
            message: res.data.Message,
            confirmButtonText: "确认",
          });
        } else {
          Dialog({
            message: res.data.Message,
            confirmButtonText: "确认",
          });
        }
    });
  };
  query();
}



const query = () => {
  if (form.name == '') {
    Dialog({
      message: "申请人不能为空!",
      confirmButtonText: "确认",
    });
  } else if (form.queryphone == '') {
    Dialog({
      message: "手机号不能为空!",
      confirmButtonText: "确认",
    });
  } else {
    let data = {
      name: form.name,
      phone: form.queryphone,
    };
    getQuery(data).then((ncquery) => {
      console.log(ncquery)
      if (ncquery.status == 200) {
        if (ncquery.data.tableData == '') {
          Dialog({
            message: '没有查询到相关开票信息!',
            confirmButtonText: "确认",
          });
        } else {
          console.log(ncquery.data.tableData,tableData);
          tableData.value = ncquery.data.tableData;

        }
      } else {
        Dialog({
          message: ncquery.data.message,
          confirmButtonText: "确认",
        });
      }
    });
  }
};



let handleSelectionChange=(selection) =>{
  gettableData = selection;
  if (selection.length > 1) {
    Dialog({
      message: "只能选择一行",
      confirmButtonText: "确认",
    });
  }else{
    if(gettableData!=''){
      if(gettableData[0]['status']!=='可开票'){
        Dialog({
          message: "请选择可开票数据!",
          confirmButtonText: "确认",
        });
      }else{
        Dialog({message: '温馨提示\n' +
              '  发票内容:*生产生活服务*肿瘤基因检测费， 若发票内容需修改，请联系销售人员，谢谢。',});
      }
    }

  }

  // this.gettableData = selection.map((item) => item.id);
  // this.gettableData = this.$refs.multipleTable,selection.map((item) => item,id);
};

let validatePhoneNumber=(str)=>{
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return reg.test(str)
}
let validateEmail=(str)=>
{
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  if(str.value=''){
    return;
  }
  if(!reg.test(str)){
    Dialog({
      message: "税号不能为空!",
      confirmButtonText: "确认",
    });
  }

}

</script>
<style lang="scss" scoped>
.el-link {
  font-size: 20px;
}
</style>